import script from "./CartItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CartItem.vue?vue&type=script&setup=true&lang=js"

import "./CartItem.vue?vue&type=style&index=0&id=65e0d719&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e0d719"]])

export default __exports__